const f = {
  color: {
    error: {
      text: "#b83525ff",
      icon: "#ff4747ff",
      borderColor: "#e54a32ff",
      background: "#fff0e8ff"
    },
    info: {
      text: "#263aadff",
      icon: "#4176faff",
      borderColor: "#4176faff",
      background: "#ebf5ffff"
    },
    success: {
      text: "#222923ff",
      icon: "#47c47dff",
      borderColor: "#47c47dff",
      background: "#f2fff0ff"
    },
    warning: {
      text: "#a35214ff",
      icon: "#ffb83dff",
      borderColor: "#fabf5aff",
      background: "#fff6e5ff"
    },
    ai: {
      text: "#5d407aff",
      icon: "#9163bfff",
      borderColor: "#9747fcff",
      background: "#f9f2ffff"
    }
  }
};
export {
  f as alert
};
